
export type EmfWidgetThemeType = 'dark' | 'light';
export type EmfWidgetFilterControlType = "checkbox" | "radio" | "dropdown" | "combobox" | 'date' | 'daterange';
export type EmfWidgetPreferenceItemType = 'favourite' | 'like' | 'dislike';


export enum EmfWidgetType {

  //#region chart group
  business_flow = 'business_flow',
  conversion_rates = 'conversion_rates',
  exposure_capacity_warnings = 'exposure_capacity_warnings',
  ingestion_accuracy = 'ingestion_accuracy',
  ingestion_team = 'ingestion_team',
  marine_team = 'marine_team',
  new_business_vs_renewal_premium = 'new_business_vs_renewal_premium',
  premium_vs_target = 'premium_vs_target',
  license_allocation = 'license_allocation',
  license_usage = 'license_usage',
  quoted_premium_vs_bond_premium = 'quoted_premium_vs_bond_premium',
  risk_appetite_rates = 'risk_appetite_rates',
  risk_appetite_ratio = 'risk_appetite_ratio',
  risk_status_and_esitmated_premium = 'risk_status_and_esitmated_premium',
  stacked_bar_chart = 'stacked_bar_chart',
  submission_score = 'submission_score',
  cybercube_risk_score = 'cybercube_risk_score',
  submission_metrics = 'submission_metrics',
  quote_metrics = 'quote_metrics',
  jtbd_metrics = 'jtbd_metrics',
  broker_submission_count_trend = 'broker_submission_count_trend',
  broker_policy_count_trend = 'broker_policy_count_trend',
  broker_quote_count_trend = 'broker_quote_count_trend',
  //#endregion end chart group


  //#region grid
  premium_paid_info = 'premium_paid_info',
  recently_booked_risk = 'recently_booked_risk',
  renewal_history = 'renewal_history',
  tasks = 'tasks',
  cybercube_risk_signals = 'cybercube_risk_signals',
  broker_comparison_quote_conversion_rate_ranking = 'broker_comparison_quote_conversion_rate_ranking',
  broker_comparison_policy_conversion_rate_ranking = 'broker_comparison_policy_conversion_rate_ranking',
  broker_comparison_submission_appetite_rate_ranking = 'broker_comparison_submission_appetite_rate_ranking',
  broker_comparison_submission_rankings = 'broker_comparison_submission_rankings',
  //#endregion grid

  //#region html  
  top_brokers = 'top_brokers',
  top_countries = 'top_countries',
  exact_details = 'exact_details',
  underwriting_details = 'underwriting_details',
  risk_additional_info = 'risk_additional_information',
  risk_information = 'risk_information',
  risk_premium_summary = 'risk_premium_summary',
  global_disaster_map = 'global_disaster_map',
  dnb = 'dnb',
  news = 'news',
  industry_classification = 'industry_classification',
  new_and_renewals_by_key_account = 'new_and_renewals_by_key_account',
  new_and_renewals_by_priority = 'new_and_renewals_by_priority',
  urgent_task = 'urgent_task',
  //#endregion html

  llm = 'llm',
  powerbi = 'powerbi',
  qliksense = 'qliksense',
  qliksense_embed = 'qliksenseembed',
  qliksense_iframe = 'qliksense_iframe',
  knowledgegraph = 'knowledgegraph',
  knowledgegraphdot = 'knowledgegraphdot',
  widgetgroup = 'widgetgroup',

  quote_conversion_rates = 'quote_conversion_rates',
  submission_conversion_rates = 'submission_conversion_rates',
  risk_retention_rates = 'risk_retention_rates',

  risk_status_and_esitmated_premium_v2 = 'risk_status_and_esitmated_premium_v2',
  new_business_vs_renewal_premium_v2 ='new_business_vs_renewal_premium_v2',
  broker_submission_count_trend_v2 = 'broker_submission_count_trend_v2',
  broker_policy_count_trend_v2 = 'broker_policy_count_trend_v2',
  broker_policy_gwp_trend_v2 = 'broker_policy_gwp_trend_v2',
  quote_issued_count_trend_v2 = 'quote_issued_count_trend_v2',

  broker_comparison_quote_conversion_rate_ranking_mcdr = 'broker_comparison_quote_conversion_rate_ranking_mcdr',
  broker_comparison_policy_conversion_rate_ranking_mcdr = 'broker_comparison_policy_conversion_rate_ranking_mcdr',
  broker_comparison_submission_appetite_rate_ranking_mcdr = 'broker_comparison_submission_appetite_rate_ranking_mcdr',
  broker_comparison_submission_rankings_mcdr = 'broker_comparison_submission_rankings_mcdr',

  business_flow_legacy = 'business-flow',
  conversion_rates_legacy = 'conversion-rates',
  exposure_capacity_warnings_legacy = 'exposure-capacity-warnings',
  new_business_vs_renewal_premium_legacy = 'new-business-vs-renewal-premium',
  premium_vs_target_legacy = 'premium-vs-target',
  quoted_vs_bond_premium_legacy = 'quoted-vs-bond-premium',
  risk_appetite_rates_legacy = 'risk-appetite-rates',
  risk_appetite_ratio_legacy = 'risk-appetite-ratio',
  risk_status_and_estimated_premium_legacy = 'risk-status-and-esitmated-premium',
  risk_status_and_estimated_premium_legacy2 = 'risk-premium',
  submission_score_legacy = 'submission-score',
  cybercube_risk_score_legacy = 'cyber-cube-risk-score',
  premium_paid_info_legacy = 'premium-paid-info',
  recently_booked_legacy = 'recentlybooked',
  renewal_history_legacy = 'renewal-history',
  cybercube_risk_signals_legacy = 'cyber-cube-signals',
  risk_additional_info_legacy = 'risk-additional-information',
  risk_premium_summary_legacy = 'risk-premium-summary',
  global_disaster_map_legacy = 'global-disaster-map',
  industry_classification_legacy = 'industry-classification',
  new_and_renewals_by_key_account_legacy = 'uwr-view-new-and-renewals-by-key-account',
  new_and_renewals_by_priority_legacy = 'new-and-renewals-by-priority',
  new_and_renewals_by_priority_legacy2 = 'uwr-view-priority-new-and-renewals',
  urgent_task_legacy = 'urgent-task',
  qliksense_iframe_legacy = 'qliksense-iframe'
}

export interface IEmfWidget {
  config: EmfWidgetConfig;
  children?: JSX.Element;
  customHeader?: JSX.Element;
  customFooter?: JSX.Element;
  loading?: boolean;
  settings?: EmfWidgetSettingItem[];
  filters?: EmfWidgetFilterGroup[];
  visualizations?: EmfWidgetFilterGroup[];
  onFiltersApplied?: (selectedFilters: EmfWidgetFilterGroup[]) => void;
  onSettingsApplied?: (selectedItems: EmfWidgetSettingItem[]) => void;
  onVisualizationsApplied?: (selectedFilters: EmfWidgetFilterGroup[]) => void;
  onFiltersClose?: () => void;
  onSettingsClose?: () => void;
  onVisualizationsClose?: () => void;
  onRefresh?: (val: boolean) => void;
  onAttrChange?: (val: EmfWidgetConfig) => void;
  onExpand?: (val: boolean) => void;
  onPreferenceItemClick?: (item: EmfWidgetPreferenceItemType, value: any) => void;
}

export class EmfWidgetConfig {
  constructor() {
    this.actionPanel = new EmfWidgetActionPanelConfigModel();
    this.preferenceValues = new UserWidgetPreferenceModel();
  }
  accessKey: string;
  target?: string = '';
  div?: Element = null;
  title?: string;
  type?: string;
  subTitle?: string;
  height?: number;
  attr?: string;
  theme?: EmfWidgetThemeType = 'light';
  primaryColor?: string = '#a38300';
  header?: boolean = true;
  footer?: boolean = false;
  filter?: boolean = false;
  refresh?: boolean = true;
  setting?: boolean = false;
  expand?: boolean = true;
  visualization?: boolean = false;
  preference?: boolean = false;
  preferencePosition?: 'top' | 'bottom' = 'bottom';
  preferenceValues?: UserWidgetPreferenceModel;
  padding?: boolean = true;
  forcePadding?: boolean = false;
  border?: boolean = false;
  forceBorder?: boolean = false;
  layoutContainerClasses?: string;
  attrKeyValue?: { [key: string]: string };
  widgetType?: EmfWidgetType;
  actionPanel?: EmfWidgetActionPanelConfigModel;
}


export class EmfWidgetFilterGroup {
  constructor(
    label: string,
    controlType: EmfWidgetFilterControlType,
    items: EmfWidgetFilterItem[],
    placeholder: string = '',
    order: number = 1,
    active: boolean = true
  ) {
    this.label = label;
    this.controlType = controlType;
    this.items = items;
    this.placeholder = placeholder;
    this.order = order;
    this.active = active;
  }
  label: string;
  controlType: EmfWidgetFilterControlType;
  items: EmfWidgetFilterItem[];
  placeholder: string;
  order: number;
  active: boolean;

  isAnySelected(): boolean {
    if (this.controlType == 'daterange' || this.controlType == 'date') {
      return this.items.some(i => i.value);
    }
    return this.items?.some(i => i.selected);
  }
}

export class EmfWidgetFilterItem {
  constructor(id: string, label: string, value: string, selected: boolean = false) {
    this.id = id;
    this.label = label;
    this.value = value;
    this.selected = selected;
  }
  id: string;
  label: string;
  value: string;
  selected: boolean;
}

export class EmfWidgetSettingGroup {
  constructor(
    label: string,
    items: EmfWidgetSettingItem[],
    order: number = 1
  ) {
    this.label = label;
    this.items = items;
    this.order = order;
  }
  label: string;
  items: EmfWidgetSettingItem[];
  order: number;
}

export class EmfWidgetSettingItem {
  id: number
  name: string
  code: string
  enabled: boolean
}


export class EmfWidgetActionPanelConfigModel {
  constructor() {
    this.filters = new EmfWidgetActionPanelConfig('APPLY FILTERS', 'RESET');
    this.settings = new EmfWidgetActionPanelConfig();
    this.visualizations = new EmfWidgetActionPanelConfig();
  }
  filters: EmfWidgetActionPanelConfig;
  settings: EmfWidgetActionPanelConfig;
  visualizations: EmfWidgetActionPanelConfig;
}

export class EmfWidgetActionPanelConfig {

  constructor(okText: string = 'SAVE', cancelText: string = 'CANCEL') {
    this.okText = okText;
    this.cancelText = cancelText;
  }
  okText: string;
  cancelText: string;
}

export interface IEmfWidgetSetting {
  id: number;
  name: string;
  code: string;
  enabled: boolean;
}

export class UserWidgetPreferenceModel {
  constructor() {
    this.like = false;
    this.dislike = false;
    this.favourite = false;
    this.chartType = '';
  }
  like: boolean;
  dislike: boolean;
  favourite: boolean;
  chartType: string;
}

//#region API data models

export interface EmfWidgetDbConfig {
  preference: boolean
  preferencePosition?: 'top' | 'bottom'
  header: boolean
  footer: boolean
  filter: boolean
  setting: boolean
  refresh: boolean
  expand: boolean
  visualization: boolean
  padding: boolean
  border: boolean
}

export interface EmfWidgetDbSetting {
  name: string,
  code: string,
  enabled: boolean,
  desc: string;
}

export interface EmfWidgetDbParam {
  name: string
  desc: string
  value: string
  readonly: boolean
  mandatory: boolean
  mapping: string;
}

export class EmfWidgetDbModel implements IOrderComparable {
  id: string
  type: string
  name: string
  title: string
  subTitle: string;
  description: string
  category: string
  icon: string
  height: string
  width: string
  active: boolean
  version: string
  params: EmfWidgetDbParam[]
  settings: EmfWidgetDbSetting[]
  order: number
  config: EmfWidgetDbConfig
}

export interface IOrderComparable {
  order: number;
}

export class ChartConfigModel {
  chartId: string;
  valueField?: string;
  categoryField?: string;
  xField?: string;
  yField?: string;
  theme?: EmfWidgetThemeType;
  primaryColor?: string;
  data: any;
  height?: number;
  seriesData?: any[];
  showLegend?: boolean = true;
  legendPosition?: 'top' | 'right' | 'bottom' | 'left' = 'bottom';
  currencyCode?: string;
  hideBullets?: boolean
}

export class EmfTargetConfigDbModel {
  constructor() {
    this.widgets = [];
  }
  id: string
  accessKey: string
  target: string
  active: boolean
  domain: string
  widgets: EmfWidgetDbModel[]
}

export class EmfTargetMappingModel {
  target: string;
  domain: string;
}


//#endregion
